import React, { useEffect } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Logo from '../../../images/logo.png';

const PrintRentall = ({
  editType, isShow, editData, onChangeFunc, saveFunc, toggleFunc, rentType = 'advance', tenantList = [],
   printWindow
}) => {
  const {
    prepaymentDate,
    prepaymentAmount,
    tenantName,
    paymentCode,
    rentalSpace,
    rentalDate,
    rentalAmount,
    hasServiceFee,
    serviceFee,
    serviceFeePercent,
    hasMealFee,
    mealFee,
    totalAmount,
    invoiceNumber,
    itemType,
    remarks,
    status,
    code
  } = editData;

  const rentalSpaceOptions = [
    { label: "C+D區", value: "C+D區" },
    { label: "C區矮沙發+D區", value: "C區矮沙發+D區" },
    { label: "D區", value: "D區" },
    { label: "G區(大教室1)", value: "G區(大教室1)" },
    { label: "F區(大教室2)", value: "F區(大教室2)" },
    { label: "I區", value: "I區" },
    { label: "H區(小教室1)", value: "H區(小教室1)" },    
    { label: "J區(小教室2)", value: "J區(小教室2)" },
    { label: "A區", value: "A區" },
    { label: "E區(實驗教室)", value: "E區(實驗教室)" },
  ];

  useEffect(() => {
    const targetWindow = printWindow || window; 
    
    setTimeout(() => {
      targetWindow.print(); 
      
      const afterPrintHandler = () => {
        targetWindow.close();
      };
      
      targetWindow.addEventListener('afterprint', afterPrintHandler);

      return () => {
        targetWindow.removeEventListener('afterprint', afterPrintHandler);
      };
      
    }, 500);

  }, [printWindow]);

  return (
    <div className="print-document-container" style={{
      margin: '0 auto',
      fontSize: '14px',
      minWidth: '700px',
      maxWidth: '700px',
      padding: '0',
      height: '297mm', // 設定為 A4 紙張高度
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box', // 確保 padding 不會增加總高度
    }}>
      
      {/* 第一聯區塊 */}
      <div style={{ position: 'relative', overflow: 'hidden' }}>
        <div className="u-small-title" style={{margin:'auto', width:'200px',backgroundColor:'#291e1b', padding: '16px'}}>
            <img src={Logo} width="120px" alt='' />
        </div>
        <div style={{textAlign:'center',fontSize:'20px', fontWeight:'bold'}}>場租收入明細單</div>

        {/* 減少 paddingBottom 以節省垂直空間 */}
        <form className="u-form" style={{ margin: '0 0 0 auto', width: '95%', paddingBottom:'20px' }}>
          <div style={{position:'absolute', left:'-10px', top:'150px'}}>第<br/><br/><br/>一<br/><br/><br/>聯</div>

          {/* 預收資訊區塊，僅預收租借顯示 */}
            <div style={{ display: 'flex', border: '1px solid black' }}>
              <div style={{ flex: 1, padding: '8px', display: 'flex', flexDirection: 'column' }}>
                <label className="" >編碼:{code}</label>
              </div>
            </div>
          {rentType === 'advance' && (
            <div style={{ display: 'flex', border: '1px solid black' }}>
              {/* 預款日期 */}
              <div style={{ flex: 1, padding: '8px', borderRight: '1px solid black', display: 'flex', flexDirection: 'column' }}>
                <label className="" >預款日期:{typeof prepaymentDate === 'string' ? prepaymentDate.split('T')[0]: ''}
                    
                </label>

              </div>
              {/* 預收金額 */}
              <div style={{ flex: 1, padding: '8px', borderRight: '1px solid black', display: 'flex', flexDirection: 'column' }}>
                <label className="" >預收金額:{prepaymentAmount|| ''}</label>
              </div>
            </div>
          )}
          {/* 承租人與收款後五碼 */}
          <div style={{ display: 'flex', border: '1px solid black' }}>
            {/* 承租人 */}
            <div style={{ flex: 1, padding: '8px',borderRight: '1px solid black', display: 'flex', flexDirection: 'column' }}>
              <label className="" >承租人:{tenantName || ''}</label>
            </div>
            {/* 收款後五碼，僅預收租借顯示 */}
            {rentType === 'advance' && (
              <div style={{ flex: 1, padding: '8px', borderRight: '1px solid black', display: 'flex', flexDirection: 'column' }}>
                <label className="" >收款後五碼:{paymentCode || ''}</label>

              </div>
            )}
          </div>

          {/* 承租空間 */}
          <div style={{ display: 'flex', border: '1px solid black' }}>
            <div style={{  flex: 1,  padding: '8px', borderRight: '1px solid black' }}>承租空間:{rentalSpace || ''}</div>

          </div>

          {/* 承租日期與場租金額 */}
          <div style={{ display: 'flex', border: '1px solid black' }}>
            {/* 承租日期 */}
            <div style={{ flex: 1, padding: '8px', borderRight: '1px solid black', display: 'flex', flexDirection: 'column' }}>
              {/* 修正：rentalDate 已經是字串，直接使用即可 */}
              <label className="" >承租日期:{typeof rentalDate === 'string' ? rentalDate.split('T')[0]: ''}</label>

            </div>
            {/* 場租金額 */}
            <div style={{ flex: 1, padding: '8px', flexDirection: 'column' }}>
              <label className="" >場租金額:{rentalAmount || ''}</label>
                            <div style={{ marginBottom: '8px' }}>
                <span style={{ marginRight: '8px' }}>場租服務費</span>
                <label style={{ marginRight: '16px' }}><input type="checkbox" disabled checked={hasServiceFee === false} onChange={e => onChangeFunc('hasServiceFee', !e.target.checked)} /> 無</label>
                <label style={{ marginRight: '16px' }}><input type="checkbox" disabled checked={hasServiceFee === true} onChange={e => onChangeFunc('hasServiceFee', e.target.checked)} /> 有</label>

                <span style={{ marginRight: '8px' }}>金額:{serviceFee || ''}</span>

                <span style={{ marginRight: '8px' }}>({serviceFeePercent || ''}%)</span>

              </div>
            </div>
          </div>

          {/* 結算金額/服務費/餐飲費 */}
          <div style={{ display: 'flex', borderLeft: '1px solid black', borderRight: '1px solid black' }}>
            <div style={{ width: '150px', padding: '8px', borderRight: '1px solid black' }}>結算金額</div>
            <div style={{ flex: 1, padding: '8px' }}>
              <div>
                <span style={{ marginRight: '8px' }}>餐點+服務費</span>
                <label style={{ marginRight: '16px' }}><input type="checkbox" disabled checked={hasMealFee === false} onChange={e => onChangeFunc('hasMealFee', !e.target.checked)} /> 無</label>
                <label style={{ marginRight: '16px' }}><input type="checkbox" disabled checked={hasMealFee === true} onChange={e => onChangeFunc('hasMealFee', e.target.checked)} /> 有</label>

                <span style={{ marginRight: '8px' }}>金額:{mealFee || ''}</span>

                <span> (含稅)</span>
              </div>
            </div>
          </div>

          {/* 總收款金額 */}
          <div style={{ display: 'flex', borderLeft: '1px solid black', borderRight: '1px solid black' }}>
            <div style={{ width: '150px', padding: '8px', borderRight: '1px solid black', display: 'flex', alignItems: 'center' }}>
              總收款金額
            </div>
            <div style={{ flex: 1, padding: '8px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>

              <span style={{ marginRight: '10px' }}>{totalAmount || ''}(已含預收金額)</span>
            </div>
          </div>

          {/* 發票號碼與品項 */}
          <div style={{ display: 'flex', border: '1px solid black' }}>
            <div style={{ width: '150px', padding: '8px', borderRight: '1px solid black' }}>發票號碼</div>
            <div style={{ flex: 1, padding: '8px', borderRight: '1px solid black', display: 'flex', flexDirection: 'column' }}>
              {invoiceNumber ? 
                (() => {
                  const regex = /([A-Z]+-\d+)/g;
                  const parts = invoiceNumber.split(regex).filter(Boolean);
                  return parts.map((part, i) => {
                    if (regex.test(part)) {
                      regex.lastIndex = 0;
                      return <React.Fragment key={i}>{part}<br /></React.Fragment>;
                    }
                    return <React.Fragment key={i}>{part}</React.Fragment>;
                  });
                })()
                : ''}
            </div>
            <div style={{ width: '150px', padding: '8px', borderRight: '1px solid black' }}>品項</div>
            <div style={{ flex: 1, padding: '8px' }}>
              {itemType || ''}
            </div>
          </div>

          {/* 備註事項 */}
          <div style={{ display: 'flex', border: '1px solid black' }}>
            <div style={{ width: '150px', padding: '8px', borderRight: '1px solid black' }}>備註事項</div>
            <div style={{ flex: 1, padding: '8px' }}>
            <label className="" style={{ lineBreak:'anywhere' }}>{remarks || ''}</label>
            </div>
          </div>
        </form>
      </div>

      {/* 第二聯區塊 */}
      <div style={{ position: 'relative', overflow: 'hidden', marginTop:'40px' }}>
        <div className="u-small-title" style={{margin:'auto', width:'200px',backgroundColor:'#291e1b', padding: '16px'}}>
              <img src={Logo} width="120px" alt='' />
          </div>
          <div style={{textAlign:'center',fontSize:'20px', fontWeight:'bold'}}>場租收入明細單</div>
          {/* 減少 paddingBottom 以節省垂直空間 */}
          <form className="u-form" style={{ margin: '0 0 0 auto', width: '95%', paddingBottom:'20px' }}>
            <div style={{position:'absolute', left:'-10px', top:'80px'}}>第<br/><br/>二<br/><br/>聯<br/><br/>會<br/><br/>計<br/><br/>留<br/><br/>存</div>

            {/* 預收資訊區塊，僅預收租借顯示 */}
              <div style={{ display: 'flex', border: '1px solid black' }}>
                <div style={{ flex: 1, padding: '8px', display: 'flex', flexDirection: 'column' }}>
                  <label className="" >編碼:{code}</label>
                </div>
              </div>
            {rentType === 'advance' && (
              <div style={{ display: 'flex', border: '1px solid black' }}>
                {/* 預款日期 */}
                <div style={{ flex: 1, padding: '8px', borderRight: '1px solid black', display: 'flex', flexDirection: 'column' }}>
                  <label className="" >預款日期:{typeof prepaymentDate === 'string' ? prepaymentDate.split('T')[0]: ''}
                      
                  </label>

                </div>
                {/* 預收金額 */}
                <div style={{ flex: 1, padding: '8px', borderRight: '1px solid black', display: 'flex', flexDirection: 'column' }}>
                  <label className="" >預收金額:{prepaymentAmount|| ''}</label>
                </div>
              </div>
            )}
            {/* 承租人與收款後五碼 */}
            <div style={{ display: 'flex', border: '1px solid black' }}>
              {/* 承租人 */}
              <div style={{ flex: 1, padding: '8px',borderRight: '1px solid black', display: 'flex', flexDirection: 'column' }}>
                <label className="" >承租人:{tenantName || ''}</label>
              </div>
              {/* 收款後五碼，僅預收租借顯示 */}
              {rentType === 'advance' && (
                <div style={{ flex: 1, padding: '8px', borderRight: '1px solid black', display: 'flex', flexDirection: 'column' }}>
                  <label className="" >收款後五碼:{paymentCode || ''}</label>

                </div>
              )}
            </div>

            {/* 承租空間 */}
            <div style={{ display: 'flex', border: '1px solid black' }}>
              <div style={{  flex: 1,  padding: '8px', borderRight: '1px solid black' }}>承租空間:{rentalSpace || ''}</div>

            </div>

            {/* 承租日期與場租金額 */}
            <div style={{ display: 'flex', border: '1px solid black' }}>
              {/* 承租日期 */}
              <div style={{ flex: 1, padding: '8px', borderRight: '1px solid black', display: 'flex', flexDirection: 'column' }}>
                <label className="" >承租日期:{typeof rentalDate === 'string' ? rentalDate.split('T')[0]: ''}</label>

              </div>
              {/* 場租金額 */}
              <div style={{ flex: 1, padding: '8px', flexDirection: 'column' }}>
                <label className="" >場租金額:{rentalAmount || ''}</label>
                              <div style={{ marginBottom: '8px' }}>
                  <span style={{ marginRight: '8px' }}>場租服務費</span>
                  <label style={{ marginRight: '16px' }}><input type="checkbox" disabled checked={hasServiceFee === false} onChange={e => onChangeFunc('hasServiceFee', !e.target.checked)} /> 無</label>
                  <label style={{ marginRight: '16px' }}><input type="checkbox" disabled checked={hasServiceFee === true} onChange={e => onChangeFunc('hasServiceFee', e.target.checked)} /> 有</label>

                  <span style={{ marginRight: '8px' }}>金額:{serviceFee || ''}</span>

                  <span style={{ marginRight: '8px' }}>({serviceFeePercent || ''}%)</span>

                </div>
              </div>
            </div>

            {/* 結算金額/服務費/餐飲費 */}
            <div style={{ display: 'flex', borderLeft: '1px solid black', borderRight: '1px solid black' }}>
              <div style={{ width: '150px', padding: '8px', borderRight: '1px solid black' }}>結算金額</div>
              <div style={{ flex: 1, padding: '8px' }}>

                <div>
                  <span style={{ marginRight: '8px' }}>餐點+服務費</span>
                  <label style={{ marginRight: '16px' }}><input type="checkbox" disabled checked={hasMealFee === false} onChange={e => onChangeFunc('hasMealFee', !e.target.checked)} /> 無</label>
                  <label style={{ marginRight: '16px' }}><input type="checkbox" disabled checked={hasMealFee === true} onChange={e => onChangeFunc('hasMealFee', e.target.checked)} /> 有</label>

                  <span style={{ marginRight: '8px' }}>金額:{mealFee || ''}</span>

                  <span> (含稅)</span>
                </div>
              </div>
            </div>

            {/* 總收款金額 */}
            <div style={{ display: 'flex', borderLeft: '1px solid black', borderRight: '1px solid black' }}>
              <div style={{ width: '150px', padding: '8px', borderRight: '1px solid black', display: 'flex', alignItems: 'center' }}>
                總收款金額
              </div>
              <div style={{ flex: 1, padding: '8px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>

                <span style={{ marginRight: '10px' }}>{totalAmount || ''}(已含預收金額)</span>
              </div>
            </div>

            {/* 發票號碼與品項 */}
            <div style={{ display: 'flex', border: '1px solid black' }}>
              <div style={{ width: '150px', padding: '8px', borderRight: '1px solid black' }}>發票號碼</div>
              <div style={{ flex: 1, padding: '8px', borderRight: '1px solid black', display: 'flex', flexDirection: 'column' }}>
                {invoiceNumber ? 
                  (() => {
                    const regex = /([A-Z]+-\d+)/g;
                    const parts = invoiceNumber.split(regex).filter(Boolean);
                    return parts.map((part, i) => {
                      if (regex.test(part)) {
                        regex.lastIndex = 0;
                        return <React.Fragment key={i}>{part}<br /></React.Fragment>;
                      }
                      return <React.Fragment key={i}>{part}</React.Fragment>;
                    });
                  })()
                  : ''}
              </div>
              <div style={{ width: '150px', padding: '8px', borderRight: '1px solid black' }}>品項</div>
              <div style={{ flex: 1, padding: '8px' }}>
                {itemType || ''}
              </div>
            </div>

            {/* 備註事項 */}
            <div style={{ display: 'flex', border: '1px solid black' }}>
              <div style={{ width: '150px', padding: '8px', borderRight: '1px solid black' }}>備註事項</div>
                <div style={{lineBreak:'anywhere', flex: 1, padding: '8px', borderRight: '1px solid black', display: 'flex', flexDirection: 'column' }}>
                {remarks || ''}
              </div>
            </div>
          </form>
      </div>
    </div>
  );
};

export default PrintRentall;